/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ProfileAuthorizedApplication,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List Authorized Applications
 */
export const listProfileAuthorizedApplications = (

 signal?: AbortSignal
) => {


      return axiosClient<ProfileAuthorizedApplication[]>(
      {url: `/profile/authorized_applications`, method: 'GET', signal
    },
      );
    }




export const getListProfileAuthorizedApplicationsQueryKey = () => {
    return [
    'profile','authorized_applications'
    ] as const;
    }


export const getListProfileAuthorizedApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listProfileAuthorizedApplications>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileAuthorizedApplications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProfileAuthorizedApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfileAuthorizedApplications>>> = ({ signal }) => listProfileAuthorizedApplications(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProfileAuthorizedApplications>>, TError, TData>
}

export type ListProfileAuthorizedApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listProfileAuthorizedApplications>>>
export type ListProfileAuthorizedApplicationsQueryError = ErrorType<void>


/**
 * @summary List Authorized Applications
 */

export function useListProfileAuthorizedApplications<TData = Awaited<ReturnType<typeof listProfileAuthorizedApplications>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProfileAuthorizedApplications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProfileAuthorizedApplicationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Revoke Authorized Application
 */
export const deleteProfileAuthorizedApplication = (
    id: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/profile/authorized_applications/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteProfileAuthorizedApplicationMutationKey = () => ['deleteProfileAuthorizedApplication'] as const;

export const getDeleteProfileAuthorizedApplicationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfileAuthorizedApplication>>, TError,DeleteProfileAuthorizedApplicationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProfileAuthorizedApplication>>, TError,DeleteProfileAuthorizedApplicationMutationVariables, TContext> => {

const mutationKey = getDeleteProfileAuthorizedApplicationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProfileAuthorizedApplication>>, DeleteProfileAuthorizedApplicationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteProfileAuthorizedApplication(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProfileAuthorizedApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProfileAuthorizedApplication>>>

    export type DeleteProfileAuthorizedApplicationMutationError = ErrorType<SchemaValidationErrorResponse>
    export type DeleteProfileAuthorizedApplicationMutationVariables = {id: number}

    /**
 * @summary Revoke Authorized Application
 */
export const useDeleteProfileAuthorizedApplication = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProfileAuthorizedApplication>>, TError,DeleteProfileAuthorizedApplicationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProfileAuthorizedApplication>>,
        TError,
        DeleteProfileAuthorizedApplicationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProfileAuthorizedApplicationMutationOptions(options), queryClient);
    }
